import React, { useState, ChangeEvent } from 'react';
import { UserIcon } from './Icons';
import { FileUploadProps } from '../types';
import styles from './FileUpload.module.scss';

export const FileUpload: React.FC<FileUploadProps> = ({
  label,
  onChange,
  accept = 'image/*',
  error,
  helperText,
  required = false,
  previewUrl,
  className = '',
}) => {
  const [preview, setPreview] = useState<string | null>(previewUrl || null);

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result as string);
      };
      reader.readAsDataURL(file);
      if (onChange) {
        onChange(file);
      }
    }
  };

  return (
    <div className={`${styles.fileUploadContainer} ${className}`}>
      {label && (
        <label className={styles.label}>
          {label}
          {required && <span className={styles.required}> *</span>}
        </label>
      )}
      <div className={styles.uploadArea}>
        <div className={styles.previewCircle}>
          {preview ? (
            <img src={preview} alt="Preview" />
          ) : (
            <UserIcon width={48} height={48} />
          )}
        </div>
        <label htmlFor="file-upload" className={styles.uploadButton}>
          {preview ? 'Change Photo' : 'Upload Photo'}
        </label>
        <input
          id="file-upload"
          type="file"
          accept={accept}
          onChange={handleFileChange}
          className={styles.hiddenInput}
        />
      </div>
      {error && <span className={styles.errorText}>{error}</span>}
      {!error && helperText && <span className={styles.helperText}>{helperText}</span>}
    </div>
  );
};
